import React, { FC } from 'react'
import { Field } from 'react-final-form'
import TextField from '../../../components/fields/TextField'
import { Grid } from '@mui/material'
import FormPhoneField from '../../../components/fields/FormPhoneField'
import { ContactFormValuesEnum } from '../types/contactFormValuesEnum'
import CivilityField from './CivilityField'
import OriginField from './OriginField'

const ContactForm: FC = () => (
	<Grid container item spacing="40px">
		<Grid container item>
			<CivilityField />
		</Grid>
		<Grid container item>
			<Field
				name={ContactFormValuesEnum.LASTNAME}
				component={TextField}
				label="creationContact.contactForm.lastname"
			/>
		</Grid>
		<Grid container item>
			<Field
				name={ContactFormValuesEnum.FIRSTNAME}
				component={TextField}
				label="creationContact.contactForm.firstname"
			/>
		</Grid>
		<Grid container item>
			<Field
				name={ContactFormValuesEnum.EMAIL}
				component={TextField}
				label="creationContact.contactForm.email"
			/>
		</Grid>
		<Grid container item>
			<Field
				name={ContactFormValuesEnum.MOBILE}
				component={FormPhoneField}
				label="creationContact.contactForm.phoneMobile"
			/>
		</Grid>
		<Grid container item>
			<OriginField />
		</Grid>
	</Grid>
)

export default ContactForm